import React from "react"

function IconFlag({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="flag"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-flag"
      {...props}
    >
      <path
        d="M6.273 3.655c.326 0 .595.237.646.548l.009.106v.292l10.368.001a1.2 1.2 0 0 1 1.136 1.588l-.049.121-2.198 4.694 2.16 4.32a1.2 1.2 0 0 1 .118.398l.009.139a1.2 1.2 0 0 1-1.07 1.193l-.13.007-10.344-.001v3.672a.655.655 0 0 1-1.3.106l-.01-.106V4.309c0-.361.294-.654.655-.654zM17.126 5.91H6.928v9.84h10.167l-2.364-4.727 2.395-5.113z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconFlag
